import React from 'react'
import ReactDOM from 'react-dom'
import App from './core/app/App'
import './index.css'
import './shared/responsive.css'

// Function to determine if snow should be shown
// Shows snow from Dec 15th to Feb 1st
const isSnowSeason = () => {
  const now = new Date();
  const month = now.getMonth(); // 0 = Jan, 11 = Dec
  const day = now.getDate();

  // Check if it is Dec 15th or later
  const isAfterDec15 = (month === 11 && day >= 15);
  // Check if it is Jan or exactly Feb 1st
  const isBeforeFeb2 = (month === 0 || (month === 1 && day === 1));

  return isAfterDec15 || isBeforeFeb2;
};

ReactDOM.render(
  <React.StrictMode>
    {isSnowSeason() && (
      <div className="snow-container">
        <div className="snow-layer" />
        <div className="snow-layer slow" />
        <div className="snow-layer fast" />
      </div>
    )}
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)